import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import transactionsAPI from '../../sources/api/transactionsAPI';

// constants
import { TRANSACTIONS_FETCH } from '../../constants/transactionsTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { transactionListSchema } from '../../schemas/Normalizr';

export function* transactionsFetch(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(TRANSACTIONS_FETCH, call(transactionsAPI.fetch, params), transactionListSchema);
  } catch (e) {
    yield put(error(TRANSACTIONS_FETCH, e));
  } finally {
    yield put(doneIndicator(TRANSACTIONS_FETCH));
  }
}

export function* watchTransactionsFetch() {
  yield takeEvery(TRANSACTIONS_FETCH, transactionsFetch);
}

export default function* root() {
  yield all([
    fork(watchTransactionsFetch)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/transactions/fetchTransactions.js